import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/** Legacy/off-topic listing patterns that should go back to the homepage. */
const HOME_REDIRECT_PATTERNS = [
  /^\/gewerbeimmobilie-mieten-/i,
  /^\/gewerbeimmobilie-kaufen-/i,
  /^\/gewerbeimmobilien-mieten-/i,
  /^\/gewerbeimmobilien-kaufen-/i,
];

/** Residential / off-topic patterns — these must stay a 404, never redirect. */
export const OFF_TOPIC_PATTERNS = [
  /^\/haus-kaufen-/i,
  /^\/wohnung-kaufen-/i,
  /^\/wohnung-mieten-/i,
  /^\/grundstueck-kaufen-/i,
];

export const isOffTopicPath = (pathname: string) =>
  OFF_TOPIC_PATTERNS.some((pattern) => pattern.test(pathname));

/**
 * Recovers malformed URLs that leaked into the index / external links:
 *  - "/https:/gewerbeflaeche-mieten.de/lagerhalle-mieten" -> "/lagerhalle-mieten"
 *  - legacy listing slugs -> "/"
 */
export const LegacyUrlRedirect = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const { pathname, search, hash } = location;

    // 1. Doubled / malformed absolute URLs pasted into the path.
    const malformed = pathname.match(/^\/https?:\/{1,2}([^/]+)(\/.*)?$/i);
    if (malformed) {
      const cleanPath = malformed[2] && malformed[2] !== "/" ? malformed[2] : "/";
      navigate(`${cleanPath}${search}${hash}`, { replace: true });
      return;
    }

    // 2. Ghost listing URLs from a previous site generation.
    if (HOME_REDIRECT_PATTERNS.some((pattern) => pattern.test(pathname))) {
      navigate("/", { replace: true });
    }
  }, [location, navigate]);

  return null;
};
